import { render } from "./InputAnnotation.vue?vue&type=template&id=815439c8&scoped=true"
import script from "./InputAnnotation.vue?vue&type=script&lang=js"
export * from "./InputAnnotation.vue?vue&type=script&lang=js"

import "./InputAnnotation.vue?vue&type=style&index=0&id=815439c8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-815439c8"]])

export default __exports__